import React from 'react'
import { env } from 'components/Helpers'

const KeySearch = ({ operatorid }) => {
  const token = window.localStorage.getItem('auth-token')

  return (
    <div className='content-box keysearch'>
      <cl-find-user-by-key
        mountPath={`/operators/${operatorid}/members`}
        apiUrl={`https://access-control.${env()}.credlock.net/api`}
        token={token}
      />
    </div>
  )
}

export default KeySearch
